
export const Product= {
  id: "",
  name: "",
  tagline: "",
  description: "",
  imageUrl: "",
  price: "",
  benefits:[]
}

export const NavLink= {
  label: "",
  href: "",
}
